interface SectionTitleProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: React.ReactNode;
}

export default function SectionTitle({ title, subtitle, icon, action }: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-primary-500" />
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
            {icon && <i className={`${icon} text-primary-500`} />}
            {title}
          </h2>
          {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}